export default __webpack_public_path__ + "9d28c003856c9695de9d72270025aba5.png";